import { useState, useCallback } from 'react';
import axios from 'axios';
import { validateTokenAndAccess } from '../../services/auth.service';
import { storeToken } from '../../utils/tokenManager';
import { getSSOURL } from '../../config/api.config';
import { showSuccess, showError } from '../../services/notification.service';

export const useSSOLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const initiateSSOLogin = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await axios.get(`${getSSOURL()}/ias/Sign_on`, {
        headers: {
          'url-type': 'swt-ui',
          'applicationid': 'b13b12a7-2757-455d-8205-fd2b5e5941c9'

        }
      });
      
      if (response.data && typeof response.data === 'string') {
        // Keep loader visible during redirect
        window.location.href = response.data;
      } else {
        console.error('No federate link found in response');
        setError('No federate link received from authentication service');
        setIsLoading(false);
      }
    } catch (err) {
      console.error('Authentication error:', err);
      setError('Failed to initiate SSO login. Please try again.');
      setIsLoading(false);
    }
  };

  const processSSOCallback = useCallback(async (params) => {
    setIsLoading(true);
    setError(null);
    
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = `${getSSOURL()}/login?${queryString}`;
      
      const response = await axios.get(url, {
        headers: {
          'url-type': 'swt-ui',
          'applicationid': 'b13b12a7-2757-455d-8205-fd2b5e5941c9'

        },
        responseType: 'text'
      });
      
      const federateResponse = JSON.parse(response.data);
      
      if (federateResponse && federateResponse.token) {
        // Validate token and get decoded data
        const decodedData = await validateTokenAndAccess(federateResponse.token);
        
        // Store token with expiry information from decoded data
        storeToken(federateResponse.token, decodedData);
        
        // Store decoded token data
        localStorage.setItem('decodedTokenData', JSON.stringify(decodedData));
        
        // showSuccess('Login successful! Redirecting...', 2000);
        
        // Keep loader visible until redirect completes
        setTimeout(() => {
          window.location.href = '/';
        }, 500);
      } else {
        throw new Error('No token found in response');
      }
    } catch (err) {
      console.error('Federate login error:', err);
      setIsLoading(false);
      
      if (err.message && err.message.includes('Contact SWT team')) {
        setError(err.message);
        return;
      }
      
      let errorMessage = 'Failed to complete SSO login. Please try again.';
      try {
        if (err.response && err.response.data) {
          const errorData = JSON.parse(err.response.data);
          errorMessage = errorData.error || errorMessage;
        }
      } catch (parseError) {
        // Use default error message
      }
      
      setError(errorMessage);
      
      setTimeout(() => {
        window.location.href = '/login';
      }, 3000);
    }
  }, []);

  return {
    isLoading,
    error,
    initiateSSOLogin,
    processSSOCallback
  };
};
